import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { ISiteConfiguration } from '@appShared/interfaces/[Interface-based]/site-configuration.interface';
import { AppActions } from '../actions';

export interface AppState {
  config: ISiteConfiguration;
  hasVerifiedSSN: boolean;
  error: string;
}

const intialAppState: AppState = {
  config: null,
  hasVerifiedSSN: false,
  error: ''
};

export const getAppFeatureState = createFeatureSelector<AppState>('app');

export const appReducer = createReducer<AppState>(
  intialAppState,
  on(AppActions.loadSiteConfigSuccess, (state, action): AppState => {
    return {
      ...state,
      config: action.siteConfig,
      error: ''
    };
  }),
  on(AppActions.loadSiteConfigFailure, (state, action): AppState => {
    return {
      ...state,
      config: null,
      error: action.error
    };
  }),
  on(AppActions.setHasVerifiedSSN, (state): AppState => {
    return {
      ...state,
      hasVerifiedSSN: true
    };
  }),
  on(AppActions.setUserProfile, (state, action): AppState => {
    const userProfile = action.profile;
    return {
      ...state,
      config: { ...state.config, userProfile }
    };
  }),
  on(AppActions.toggleIsAdminOnlyModeSuccess, (state, action): AppState => {
    const isAdminOnlyMode = action.isAdminOnlyMode;
    return {
      ...state,
      config: { ...state.config, isAdminOnlyMode },
      error: ''
    };
  }),
  on(AppActions.toggleIsAdminOnlyModeFailure, (state, action): AppState => {
    return {
      ...state,
      config: null,
      error: action.error
    };
  })
);
